import styled from '@emotion/styled';

export const ContentWrapper = styled('div')(() => ({
  flex: '40%',
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  flexDirection: 'column',
  overflow: 'auto',
  '@media(max-width: 768px)': {
    display: 'none',
    flex: 'unset',
    justifyContent: 'center',
    minHeight: '270px',
    maxHeight: '450px',
  },
}));
